
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { IForgotPassword } from '../models/forgotpasswordInput';
import { Observable } from 'rxjs';
import { ResultOutputModel } from '../models/resultOutputModel';
import { IImportPropertyOutput } from '../models/importPropertyOutput';
import { environment } from '../../../environments/environment';
import { RestService } from '../providers/rest.service';

@Injectable()
export class PropertyImportService extends RestService {
    readonly BaseUrl = environment.base_url;
    //_user: Observable<ResultOutputModel>;
    importPropertyResponse = {} as IImportPropertyOutput;
    resultOutputModel = {} as ResultOutputModel;

    validateProperty(postData: any): Observable<IImportPropertyOutput> {
        return this.postForEntityObject<IImportPropertyOutput>("/import/validate", postData).pipe(
            map(response => {
                this.importPropertyResponse = response;
                return this.importPropertyResponse;
            }));
    }

    importProperty(postData: IImportPropertyOutput): Observable<ResultOutputModel> {
        return this.postForEntityObject<ResultOutputModel>("/import", postData).pipe(
            map(response => {
                this.resultOutputModel = response;
                return this.resultOutputModel;
            }));
    }
}